"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayTripsThemedPageStatus = void 0;
var DayTripsThemedPageStatus;
(function (DayTripsThemedPageStatus) {
    DayTripsThemedPageStatus["Draft"] = "draft";
    DayTripsThemedPageStatus["Active"] = "active";
    DayTripsThemedPageStatus["Archived"] = "archived";
    DayTripsThemedPageStatus["Deleted"] = "deleted";
})(DayTripsThemedPageStatus || (exports.DayTripsThemedPageStatus = DayTripsThemedPageStatus = {}));
//# sourceMappingURL=day-trips-themed-page-status.enum.js.map